import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import FacadeReform from './pages/FacadeReform';
import Projects from './pages/Projects';
import Differentials from './pages/Differentials';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Header from './components/Header';
import Footer from './components/Footer';
import SocialButtons from './components/SocialButtons';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProjects from './pages/admin/AdminProjects';
import AdminBlog from './pages/admin/AdminBlog';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminFAQs from './pages/admin/AdminFAQs';
import AdminGallery from './pages/admin/AdminGallery';
import AdminServices from './pages/admin/AdminServices';
import AdminDifferentials from './pages/admin/AdminDifferentials';
import AdminSettings from './pages/admin/AdminSettings';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/projects" element={<AdminProjects />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/testimonials" element={<AdminTestimonials />} />
            <Route path="/admin/faqs" element={<AdminFAQs />} />
            <Route path="/admin/gallery" element={<AdminGallery />} />
            <Route path="/admin/services" element={<AdminServices />} />
            <Route path="/admin/differentials" element={<AdminDifferentials />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            
            {/* Public Routes */}
            <Route path="/*" element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/quem-somos" element={<About />} />
                  <Route path="/servicos" element={<Services />} />
                  <Route path="/reforma-fachada" element={<FacadeReform />} />
                  <Route path="/projetos" element={<Projects />} />
                  <Route path="/diferenciais" element={<Differentials />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/contato" element={<Contact />} />
                </Routes>
                <Footer />
                <SocialButtons />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
